import { basicPath } from '../basicPath';

export const fetchEmailLogs = (params) => async (dispatch) => {
    const path = '/mp/email-logs/daterange';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}